import {
  ICalendarWorkTemplateBase,
  WorkOrderStatus,
} from "@miplatform/types";
import { getGUIDArray } from "@miplatform/utils";

function buildAssignmentTemplateFilter(
  templates: ICalendarWorkTemplateBase[],
  eventType: string
): Record<string, unknown> {
  return {
    assignment: {
      [eventType]: {
        [`${eventType}TemplateId`]: {
          in: getGUIDArray(templates.map((template) => template.id)),
        },
      },
    },
  };
}

export function buildUnassignedWorkOrdersFilters(
  templates: ICalendarWorkTemplateBase[],
  eventType: string
): Record<string, unknown> {
  if (templates.length === 0) {
    return {};
  }

  return {
    isCustomWorkOrder: {
      eq: false,
    },
    assignedUserId: {
      eq: null,
    },
    ...buildAssignmentTemplateFilter(templates, eventType),
    workOrderStatus: {
      ne: WorkOrderStatus.Hold,
    }
  };
}
